'use client'

import React from 'react'

import { Button } from '@/packages/news-ui/basic/button'
import { getPublicEnv } from '@/shared/env'
import { useI18n } from '@/shared/providers'

export function LoggedOut() {
    const runtimeEnv = getPublicEnv()
    const { i18n } = useI18n()

    return (
        <React.Fragment>
            <Button
                variant="outline"
                size="sm"
                onClick={() => {
                    window.location.href = `${runtimeEnv.NEXT_PUBLIC_TAONGA_PORTAL_URL}?action=login`
                }}
            >
                {i18n.BUTTON_LOGIN}
            </Button>

            <Button
                color="info"
                size="sm"
                onClick={() => {
                    window.location.href = `${runtimeEnv.NEXT_PUBLIC_TAONGA_PORTAL_URL}?action=signup`
                }}
            >
                {i18n.BUTTON_SIGNUP}
            </Button>
        </React.Fragment>
    )
}
